<template>
    <body>
        <main class="main-content  mt-0">
            <section>
                <div class="page-header min-vh-100">
                    <div class="container">
                        <div class="row">
                            <div class="col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0 mx-auto">
                                <div class="card card-plain">
                                    <div class="card-header pb-0 text-start">
                                        <h4 class="font-weight-bolder">Connexion</h4>
                                        <p class="mb-0">Entrez votre adresse e-mail et votre mot de passe pour vous
                                            connecter</p>
                                    </div>
                                    <div class="card-body">

                                        <form id="app" @submit="checkLogin" action="#" method="post" novalidate="true">

                                            <div class="error-container" v-if="hasErrors">
                                                <div class="alert alert-danger text-center">
                                                    <b>Veuillez corriger les erreurs suivantes:</b>
                                                    <ul v-for="(error, field) in errors" :key="field"
                                                        class="text-left"> {{ error }} </ul>
                                                </div>
                                            </div>

                                            <div class="form-group" :class="{ 'has-error': errors.username }">
                                                <input id="username" v-model="username" type="email" name="username"
                                                    class="form-control form-control-lg" placeholder="* Identifiant"
                                                       pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                                       required />
                                                <span v-if="errors.username" class="text-danger"> <i
                                                        class="fa-solid fa-circle-exclamation text-danger text-sm opacity-10"></i>
                                                    {{ errors.username }} </span>
                                            </div>

                                            <div class="form-group" :class="{ 'has-error': errors.password }">
                                                <input id="password" v-model="password" type="password"
                                                    class="form-control form-control-lg" placeholder="* Mot de passe"
                                                    required />
                                                <span v-if="errors.password" class="text-danger"> <i
                                                        class="fa-solid fa-circle-exclamation text-danger text-sm opacity-10"></i>
                                                    {{ errors.password }} </span>
                                            </div>

                                            <!-- <div class="form-check form-switch">
                                                <input class="form-check-input" type="checkbox" id="rememberMe">
                                                <label class="form-check-label" for="rememberMe">Se souvenir de moi</label>
                                            </div> -->

                                            <div class="text-center">
                                                <button type="submit" class="btn btn-lg btn-primary btn-lg w-100 mt-4 mb-0"
                                                    :disabled="hasEmptyFields">Connexion</button>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="col-6 d-lg-flex d-none h-100 my-auto pe-0 position-absolute top-0 end-0 text-center justify-content-center flex-column">
                                <div class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                                    style="background-image: url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg'); background-size: cover;">
                                    <span class="mask bg-gradient-primary opacity-6"></span>
                                    <h4 class="mt-5 text-white font-weight-bolder position-relative">"L'attention est la
                                        nouvelle monnaie"</h4>
                                    <p class="text-white position-relative">Plus l'écriture semble simple, plus l'écrivain
                                        met d'efforts dans le processus.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </body>
</template>


<script>
import { accountService } from '@/_services'

export default {
    data() {
        return {
            username: null,
            password: null,
            errors: {
                username: null,
                password: null,
            },
        };
    },
    computed: {
        hasErrors() {
            return Object.values(this.errors).some(error => error != null);
        },
        hasEmptyFields() {
            return !this.username || !this.password;
        },
    },
    methods: {
        async checkLogin(e) {
            this.errors = {
                username: null,
                password: null,
            };

            if (!this.username) {
                this.errors.username = "Le champ 'Identifiant' est vide !";
            } else if (!this.validUsername(this.username)) {
                this.errors.username = "L'identifiant doit être en format d'email e.g. exemple@exemple.com !";
            }

            if (!this.password) {
                this.errors.password = "Le champ 'Mot de passe' est vide !";
            }

            e.preventDefault();

            if (Object.values(this.errors).every(error => error === null)) {
                try {
                    const response = await accountService.login({ email: this.username, password: this.password });

                    console.log('Email, password', { email: this.username, password: this.password })
                    if (response.data && response.data.accessToken) {
                        console.log(response);
                        accountService.saveToken(response.data.accessToken);
                        this.$router.push('/dashboard');
                    } else {
                        this.errors.username = "Identifiants incorrects";
                    }
                } catch (error) {
                    console.error("Erreur lors de l'authentification :", error);

                    if (error.response) {
                        // SI le serveur repond avec un code d'état différent de 200
                        if (error.response.status === 401) {
                            this.errors.username = "Identifiants incorrects !";
                        } else {
                            this.errors.username = `Erreur du serveur: ${error.response.status}`;
                        }
                    } else if (error.request) {
                        // Aucune réponse n'a été reçue
                        this.errors.username = "Pas de réponse du serveur. Veuillez réessayer plus tard.";
                    } else {
                        // Erreur lors de la configuration de la requête
                        this.errors.username = "Erreur de configuration de la requête. Veuillez réessayer plus tard.";
                    }
                }
            }
        },


        validUsername: function (username) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(username);
        },
    },
};
</script>

<style scoped lang="scss">

input:focus::placeholder,
input:not(:placeholder-shown)::placeholder {
    color: #6c757d;
    font-size: 12px;
    transition: all 0.2s ease-in-out;
}

// .error-container {
//     margin-top: 1rem;
//     max-width: 700px;
//     margin-left: auto;
//     margin-right: auto;
// }

.alert {
    padding: 10px;
    margin-bottom: 10px;
    border: 1px solid #000000;
    border-radius: 4px;
    color: #000000;
    line-height: 1;
    text-align: center;
}

.alert b {
    color: #000000;
    line-height: 3;
    text-align: center;
}
.error-message {
    color: #d9534f;
    font-size: 14px;
    margin-top: 4px;
    display: block;
    text-align: left;
}
.error-icon {
    margin-right: 5px;
    max-width: 22px;
    max-height: 22px;
}
</style>